import React, { useState } from 'react';
import { FileAddOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

/**
 * Замена <img>/<video> для старых (архивных) вложений: при ошибке загрузки
 * исходника (файл не перенесён в Nextcloud) показываем аккуратную заглушку.
 */
export default function ArchiveMedia({ src, kind = 'image', style, alt, controls = true, onClick }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        style={{
          ...style,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          border: '1px dashed #bfbfbf',
          borderRadius: 8,
          padding: 24,
          color: '#8c8c8c',
          background: '#fafafa',
        }}
      >
        <FileAddOutlined style={{ fontSize: 34 }} />
        <Typography.Text type="secondary">Архивное вложение</Typography.Text>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          Не перенесено в Nextcloud — просмотр недоступен
        </Typography.Text>
      </div>
    );
  }

  if (kind === 'video') {
    return (
      <video
        src={src}
        controls={controls}
        style={style}
        onClick={onClick}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt || ''}
      style={style}
      onClick={onClick}
      onError={() => setFailed(true)}
    />
  );
}
